export default __webpack_public_path__ + "static/media/amazon.e78d24c7.svg";